interface ErrorWithResponse {
  response: {
    status: number
  }
}

interface ErrorWithStatus {
  status: number
}

const isErrorWithResponse = (error: unknown): error is ErrorWithResponse => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null &&
    'status' in error.response &&
    typeof error.response.status === 'number'
  )
}

const isErrorWithStatus = (error: unknown): error is ErrorWithStatus => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof error.status === 'number'
  )
}

export const getErrorStatus = (error: unknown): number | null => {
  if (typeof error !== 'object' || error === null) {
    return null
  }

  if (isErrorWithResponse(error)) {
    return error.response.status
  }
  if (isErrorWithStatus(error)) {
    return error.status
  }
  return null
}

export const showLogoutMessage = () => {
  alert('ログアウトしました。')
}
